import React from 'react';
import { Link } from 'react-router-dom';

import { Box, Button, Typography } from '@material-ui/core';

import SubHeader from '../../../../components/Header/SubHeader.component';
import { useNavigationContext } from '../../../../context/Navigation/navigation.provider';
import { useAuthDataContext } from '../../../../context/auth/auth.provider';

const Profile = () => {
  const { user } = useAuthDataContext();
  const { navigationHistory, updateNavigation, resetNavigationAccount } =
    useNavigationContext();

  const handlePush = async (title, url) => {
    await updateNavigation({
      title,
      url,
    });
  };

  return (
    <SubHeader
      content={
        <Box>
          <Typography variant="h6">
            {user.first_name + ' ' + user.last_name}
          </Typography>
        </Box>
      }
      fullActions
      actions={
        <Box>
          <Box my={2}>
            <Button
              // component={Link}
              onClick={() =>
                handlePush('Editar datos de perfil', '/account/edit-profile')
              }
              // to="/account/edit-profile"
              variant="contained"
              color="primary"
              fullWidth
            >
              Editar datos de perfil
            </Button>
          </Box>
          <Box my={2}>
            <Button
              onClick={() =>
                handlePush('Cambiar contraseña', '/account/change-password')
              }
              variant="outlined"
              color="primary"
              fullWidth
            >
              Modificar contraseña
            </Button>
          </Box>
        </Box>
      }
    ></SubHeader>
  );
};

export default Profile;
